export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12879.e396e4d8.jpg";